import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { format } from 'date-fns';
import { id } from 'date-fns/locale';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: string): string {
    return format(date, displayFormat, { locale: id });
  }
}
